import type React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, StaticRouter } from 'react-router';
import App from '../components/layout/App/App';
import store from '../redux/stores/GlobalStore';
import type { AppSsrFetchedDataType } from '../server/AppSsr';

interface EntrypointProps {
  location: string;
  ssrFetchedData: AppSsrFetchedDataType;
  onClient: boolean;
}

const Entrypoint: React.FC<EntrypointProps> = ({
  ssrFetchedData,
  location,
  onClient,
}) => {
  return (
    <Provider store={store}>
      {onClient ? (
        <BrowserRouter>
          <App ssrFetchedData={ssrFetchedData} />
        </BrowserRouter>
      ) : (
        <StaticRouter location={location}>
          <App ssrFetchedData={ssrFetchedData} />
        </StaticRouter>
      )}
    </Provider>
  );
};

export default Entrypoint;
